import { Middleware } from 'redux';
const nextTick = require('next-tick');

import { ROUTER_PUSH_ACTION } from '../redux/actions/actions-consts';
import { AppState } from '../redux/reducers';
import isAction from './helpers';
import { Navigation } from '../modules/navigation';

const routerMiddleware = (navigation: Navigation): Middleware<{}, AppState> => () => (next) => (
  action: any
): void => {
  if (isAction(action)) {
    if (action.type === ROUTER_PUSH_ACTION) {
      navigation.push(action.payload);
    }
    next(action);
    return;
  }

  nextTick(() => next(action));
};

export default routerMiddleware;
